import { render, staticRenderFns } from "./ShopSetting.vue?vue&type=template&id=7975a80e&scoped=true&"
import script from "./ShopSetting.vue?vue&type=script&lang=js&"
export * from "./ShopSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShopSetting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShopSetting.vue?vue&type=style&index=1&id=7975a80e&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7975a80e",
  null
  
)

export default component.exports